var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xxs fixed left-1 bottom-1 text-type-grey-1 opacity-50"},[_vm._v(" "+_vm._s(_vm.env)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }